const GithubIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.00757 1.08398C4.02654 1.08398 0 5.03711 0 9.92761C0 13.8368 2.57993 17.1459 6.15902 18.3171C6.60648 18.4052 6.77042 18.1268 6.77042 17.8927C6.77042 17.6877 6.75568 16.985 6.75568 16.2527C4.25006 16.7799 3.72829 15.1985 3.72829 15.1985C3.32565 14.1737 2.72899 13.9102 2.72899 13.9102C1.90882 13.3684 2.7887 13.3684 2.7887 13.3684C3.69836 13.427 4.17575 14.2762 4.17575 14.2762C4.98088 15.6232 6.27844 15.2426 6.80035 15.0083C6.87481 14.4373 7.11364 14.0419 7.36708 13.8224C5.36863 13.6174 3.26594 12.856 3.26594 9.45913C3.26594 8.49272 3.62362 7.70216 4.19035 7.08728C4.10086 6.86777 3.78771 5.95969 4.27998 4.74461C4.27998 4.74461 5.04059 4.5103 6.75539 5.6524C7.48954 5.45881 8.24682 5.36032 9.00743 5.35948C9.76803 5.35948 10.5432 5.46205 11.2592 5.6524C12.9743 4.5103 13.7347 4.74461 13.7347 4.74461C14.227 5.95983 13.9136 6.86777 13.8242 7.08728C14.406 7.70216 14.7489 8.49272 14.7489 9.45913C14.7489 12.8561 12.6462 13.6026 10.6329 13.8224C10.9611 14.1005 11.2443 14.6276 11.2443 15.4621C11.2443 16.6481 11.2295 17.5998 11.2295 17.8926C11.2295 18.1269 11.3936 18.4052 11.8409 18.3174C15.42 17.1459 18 13.8369 18 9.92775C18.0149 5.03711 13.9736 1.08398 9.00757 1.08398Z'
        />
      </svg>
    </span>
  );
};

export default GithubIcon;
